import { withRouter } from "react-router-dom";
import Discussions from './discussions/Discussions';
import DiscussionsDetail from './discussions/DiscussionsDetail';
import Qna from './qna/Qna';
import QnaDetail from './qna/QnaDetail';
import IntentMapping from './qna/IntentMapping';
import BabynameLanding from './baby-names/Babynames';
import Finder from './baby-names/Finder';
import BabynamesListing from './baby-names/BabynamesListing';
import BabynameDetail from './baby-names/BabynameDetail';
import CollectionList from './baby-names/CollectionList';
import SharedCollection from './baby-names/SharedCollection';
import Tools from './tools/Tools';
import BabySizeComparison from './tools/baby-size-comparison/BabySizeComparison';
import BabyTeething from './tools/baby-teething/BabyTeething';
import Dietplan from './tools/baby-dietplan/Dietplan';
import Breastfeeding from './tools/Breastfeeding/Breastfeeding';
import FetalDevelopmentVideo from './tools/fetus-video/FetalDevelopmentVideo';
import Weekbyweek from './tools/week-by-week/Weekbyweek';
//import PregnancyGuide from './tools/pregnancyGuide/PregnancyGuide';
import Fetalmovementtracker from './tools/fetal-movement-tracker/Fetal';
import Pis from './tools/pis/Pis';
import PisInfo from './tools/pis/PisInfo';
import PisManageReport from './tools/pis/PisManageReport';
import PisUpdateDetail from './tools/pis/PisUpdateDetail';
import PisManageReminder from './tools/pis/PisManageReminder';
import Duedate from './tools/Duedate/DueDate';
import DuedateDisclaimer from './tools/Duedate/Disclaimer';
import DuedateFaqs from './tools/Duedate/Faqs';
import DueDateDetails from './tools/Duedate/DueDateDetails';
import DietplanMom from './tools/DietplanMom/DietplanMom';
// import VaccinationLanding from './tools/vaccination/VaccinationLanding';
// import VaccinationTracker from './tools/vaccination/VaccinationTracker';
// import ChildGraph from './tools/vaccination/childGraph';
// import Emailvaccinegrowth from './tools/vaccination/emailvaccinegrowth';
// import Faq from './tools/vaccination/faq';
// import Disclaimer from './tools/vaccination/disclaimer';
// import Feedback from './tools/vaccination/feedback';
// import MarkDone from './tools/vaccination/markdone';
// import Reminder from './tools/vaccination/reminder';
import ViewChart from './tools/vaccination/viewchart';
import Face from './tools/Face/Face';
import UploadFace from "./tools/Face/UploadFace";
import SlideShow from "./tools/Face/SlideShow";
import Mybumpie from "./tools/Mybumpie/Mybumpie";
import UploadBumpie from "./tools/Mybumpie/UploadBumpie";

import BabynameLandingAmp from './baby-names-amp/BabynamesAmp';
import FinderAmp from './baby-names-amp/FinderAmp';
import BabynamesListingAmp from './baby-names-amp/BabynamesListingAmp';
import BabynameDetailAmp from './baby-names-amp/BabynameDetailAmp';
import CollectionListAmp from './baby-names-amp/CollectionListAmp';
import SharedCollectionAmp from './baby-names-amp/SharedCollectionAmp'; 
import NoPageFound from './errors/NoPageFound';

const routes = [
  {
    path: "/discussions",
    exact: true,
    component: withRouter(Discussions)
  },
  {
    path: "/discussions/page/:page",
    exact: true,
    component: withRouter(Discussions)
  },
  {
    path: "/discussions/t/:title",
    exact: true,
    component: withRouter(DiscussionsDetail)
  },
  {
    path: "/discussions/t/:title/page/:page",
    exact: true,
    component: withRouter(DiscussionsDetail)
  },
  {
    path: "/qna/questions-answers",
    exact: true,
    component: withRouter(Qna)
  },
  {
    path: "/qna/questions-answers/page/:page",
    exact: true,
    component: withRouter(Qna)
  },
  {
    path: "/qna/q/:title",
    exact: true,
    component: withRouter(QnaDetail)
  },
  {
    path: "/qna/q/:title/page/:page",
    exact: true,
    component: withRouter(QnaDetail)
  },
  {
    path: "/qna/intentmapping/:title",
    exact: true,
    component: withRouter(IntentMapping)
  },
  
  {
    path: "/baby-names",
    exact: true,
    component: withRouter(BabynameLanding)
  },
  {
    path: "/baby-names/finder",
    exact: true,
    component: withRouter(Finder)
  },
  {  
    path: /^\/baby-names\/finder\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/favorite-baby-names",
    exact: true,
    component: withRouter(CollectionList)
  },
  {
    path: /^\/baby-names\/favorite-baby-names\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(SharedCollection)
  },
  {
    path: "/baby-names/boy/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/girl/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/unisex/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/origin/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    
    path: /^\/baby-names\/origin\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/boy/origin/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/girl/origin/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/unisex/origin/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/boy\/origin\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/girl\/origin\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/unisex\/origin\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/religion/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/religion\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/boy/religion/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/girl/religion/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/unisex/religion/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/boy\/religion\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/girl\/religion\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    
    path: /^\/baby-names\/unisex\/religion\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/numerology/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/numerology\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/boy/numerology/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/girl/numerology",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/unisex/numerology",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    
    path: /^\/baby-names\/boy\/numerology\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/girl\/numerology\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/unisex\/numerology\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/rashi/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/rashi\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/boy/rashi/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/girl/rashi/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/unisex/rashi/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/boy\/rashi\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/girl\/rashi\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/unisex\/rashi\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/nakshatra/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/nakshatra\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/boy/nakshatra/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/girl/nakshatra/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/unisex/nakshatra/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    
    path: /^\/baby-names\/boy\/nakshatra\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/girl\/nakshatra\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/unisex\/nakshatra\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/starting-with/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/starting-with\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/boy/starting-with/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/girl/starting-with/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/unisex/starting-with/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    
    path: /^\/baby-names\/boy\/starting-with\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/girl\/starting-with\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/unisex\/starting-with\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/god-goddesses/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/god-goddesses\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/boy/god-goddesses/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/girl/god-goddesses/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/unisex/god-goddesses/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/boy\/god-goddesses\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/girl\/god-goddesses\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: /^\/baby-names\/unisex\/god-goddesses\/*(?!amp)[a-zA-Z0-9._-]+\/$/,
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/search",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/:any/popular-names",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/meaning-of-:any",
    exact: true,
    component: withRouter(BabynameDetail)
  },
  {
    path: "/baby-names/:any/page/:page",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/:any/:any/page/:page",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/:any/:any/:any/page/:page",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/:any/:any/:any/starting-with/:any/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/:any/:any/:any/starting-with/:any/page/:page",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/:any/:any/starting-with/:any/",
    exact: true,
    component: withRouter(BabynamesListing)
  },
  {
    path: "/baby-names/:any/:any/starting-with/:any/page/:page",
    exact: true,
    component: withRouter(BabynamesListing)
  },


  {
    path: "/tools/baby-size-comparison",
    exact: true,
    component: withRouter(BabySizeComparison)
  },
  {
    path: "/tools/baby-teething",
    exact: true,
    component: withRouter(BabyTeething)
  },
  {
    path: "/tools/baby-kids-diet-plan/",
    exact: true,
    component: withRouter(Dietplan)
  },
  {
    path: "/tools/breastfeeding-tracker",
    exact: true,
    component: withRouter(Breastfeeding)
  },
  {
    path: "/tools/fetal-development-video",
    exact: true,
    component: withRouter(FetalDevelopmentVideo)
  },
  {
    path: "/tools/pregnancy-week-by-week-tracker",
    exact: true,
    component: withRouter(Weekbyweek)
  },
  // {
  //   path: "/tools/pregnancy-week-by-week-guide/",
  //   exact: true,
  //   component: withRouter(PregnancyGuide)
  // },
  {
    path: "/tools/fetal-movement-tracker",
    exact: true,
    component: withRouter(Fetalmovementtracker)
  },
  {
    path: "/tools/pregnancy-checkup-schedule",
    exact: true,
    component: withRouter(Pis)
  },
  {
    path: "/tools/pregnancy-checkup-schedule/how-it-work",
    exact: true,
    component: withRouter(PisInfo)
  },
  {
    path: "/tools/pregnancy-checkup-schedule/manageReports/:title/:id",
    exact: true,
    component: withRouter(PisManageReport)
  },
  {
    path: "/tools/pregnancy-checkup-schedule/updateDetails/:title/:id",
    exact: true,
    component: withRouter(PisUpdateDetail)
  },
  {
    path: "/tools/pregnancy-checkup-schedule/manageReminder/:id/:title",
    exact: true,
    component: withRouter(PisManageReminder)
  },
  {
    path: "/tools/pregnancy-due-date-calculator/",
    exact: true,
    component: withRouter(Duedate)
  },
  {
    path: "/tools/pregnancy-due-date-calculator/disclaimerApp",
    exact: true,
    component: withRouter(DuedateDisclaimer)
  },
  {
    path: "/tools/pregnancy-due-date-calculator/faqsApp",
    exact: true,
    component: withRouter(DuedateFaqs)
  },
  {
    path: "/tools/pregnancy-due-date-calculator/details/:ldate/:cycle/:cdate",
    exact: true,
    component: withRouter(DueDateDetails)
  }, 
  {
    path: "/tools/pregnancy-diet-plan/",
    exact: true,
    component: withRouter(DietplanMom)
  },
  // {
  //   path: "/tools/child-vaccination-growth-tracker",
  //   exact: true,
  //   component: withRouter(VaccinationLanding)
  // },
  // {
  //   path: "/tools/child-vaccination-growth-tracker/childgraph/:any",
  //   exact: true,
  //   component: withRouter(ChildGraph)
  // },
  // {
  //   path: "/tools/child-vaccination-growth-tracker/emailvaccinegrowth/:any",
  //   exact: true,
  //   component: withRouter(Emailvaccinegrowth)
  // },
  // {
  //   path: "/tools/child-vaccination-growth-tracker/faqs",
  //   exact: true,
  //   component: withRouter(Faq)
  // },
  // {
  //   path: "/tools/child-vaccination-growth-tracker/disclaimer",
  //   exact: true,
  //   component: withRouter(Disclaimer)
  // },
  // {
  //   path: "/tools/child-vaccination-growth-tracker/feedback",
  //   exact: true,
  //   component: withRouter(Feedback)
  // },
  // {
  //   path: "/tools/child-vaccination-growth-tracker/all/:any",
  //   exact: true,
  //   component: withRouter(VaccinationTracker)
  // },
  // {
  //   path: "/tools/child-vaccination-growth-tracker/overdue/:any",
  //   exact: true,
  //   component: withRouter(VaccinationTracker)
  // },
  // {
  //   path: "/tools/child-vaccination-growth-tracker/done/:any",
  //   exact: true,
  //   component: withRouter(VaccinationTracker)
  // },
  // {
  //   path: "/tools/child-vaccination-growth-tracker/upcoming/:any",
  //   exact: true,
  //   component: withRouter(VaccinationTracker)
  // },
  // {
  //   path: "/tools/child-vaccination-growth-tracker/updatedetails/:any/:any/:any/:any/:any",
  //   exact: true,
  //   component: withRouter(MarkDone)
  // },
  // {
  //   path: "/tools/child-vaccination-growth-tracker/reminder/:any/:any/:any",
  //   exact: true,
  //   component: withRouter(Reminder)
  // },
  // {
  //   path: "/tools/child-vaccination-growth-tracker/viewchart",
  //   exact: true,
  //   component: withRouter(ViewChart)
  // }, 
  {
    path: "/tools/capture-baby-moments",
    exact: true,
    component: withRouter(Face)
  },
  {
    path: "/tools/capture-baby-moments/uploadfaces",
    exact: true,
    component: withRouter(UploadFace)
  },
  {
    path: "/tools/capture-baby-moments/slide-show",
    exact: true,
    component: withRouter(SlideShow)
  },
  {
    path: "/tools/my-baby-bump",
    exact: true,
    component: withRouter(Mybumpie)
  },
  {
    path: "/tools/uploadmybumpie",
    exact: true,
    component: withRouter(UploadBumpie)
  },

   {
    path: "/baby-names/amp/",
    exact: true,
    component: withRouter(BabynameLandingAmp)
  },
  {
    path: "/baby-names/finder/amp/",
    exact: true,
    component: withRouter(FinderAmp)
  },
  {
    path: "/baby-names/finder/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/favorite-baby-names/amp/",
    exact: true,
    component: withRouter(CollectionListAmp)
  },
  {
    path: "/baby-names/favorite-baby-names/:any/amp/",
    exact: true,
    component: withRouter(SharedCollectionAmp)
  },
  {
    path: "/baby-names/boy/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/girl/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/unisex/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/origin/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/origin/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/boy/origin/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/girl/origin/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/unisex/origin/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/boy/origin/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/girl/origin/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/unisex/origin/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/religion/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/religion/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/boy/religion/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/girl/religion/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/unisex/religion/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/boy/religion/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/girl/religion/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/unisex/religion/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/numerology/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/numerology/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/boy/numerology/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/girl/numerology/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/unisex/numerology/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/boy/numerology/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/girl/numerology/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/unisex/numerology/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/rashi/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/rashi/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/boy/rashi/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/girl/rashi/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/unisex/rashi/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/boy/rashi/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/girl/rashi/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/unisex/rashi/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/nakshatra/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/nakshatra/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/boy/nakshatra/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/girl/nakshatra/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/unisex/nakshatra/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/boy/nakshatra/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/girl/nakshatra/:any/amp",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/unisex/nakshatra/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/starting-with/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/starting-with/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/boy/starting-with/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/girl/starting-with/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/unisex/starting-with/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/boy/starting-with/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/girl/starting-with/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/unisex/starting-with/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/god-goddesses/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/god-goddesses/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/boy/god-goddesses/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },

  {
    path: "/baby-names/girl/god-goddesses/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/unisex/god-goddesses/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/boy/god-goddesses/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/girl/god-goddesses/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/unisex/god-goddesses/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/search/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/:any/popular-names/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/meaning-of-:any/amp/",
    exact: true,
    component: withRouter(BabynameDetailAmp)
  },
  {
    path: "/baby-names/:any/page/:page/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/:any/:any/page/:page/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/:any/:any/:any/page/:page/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/:any/:any/:any/starting-with/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/:any/:any/:any/starting-with/:any/page/:page/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/:any/:any/starting-with/:any/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  },
  {
    path: "/baby-names/:any/:any/starting-with/:any/page/:page/amp/",
    exact: true,
    component: withRouter(BabynamesListingAmp)
  }, 

  {
    path: "/tools",
    exact: true,
    component: withRouter(Tools)
  },
  {
    component: NoPageFound,
    status: 404
  }
];

export default routes;



// WEBPACK FOOTER //
// src/shared/routes.js